import React from "react";
import styled from "styled-components"

const Styled={
    MenuRecommendBox:styled.div`
        width:68px;
        height:20px;
        margin-right:5px;
        border-radius:5px;
        background-color:#FFD7FB;
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:column;
    `,
        MenuRecommendText:styled.p`
            font-size:10px;
            font-weight:400;
            color:#FF27E9;
            font-family:'PreFont';
        `,
}

const Event=()=>{
    return(
        <Styled.MenuRecommendBox>
            <Styled.MenuRecommendText>영수증 이벤트</Styled.MenuRecommendText>
        </Styled.MenuRecommendBox>
    )
}
export default Event